import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

export default function LearningAssetStatusPanel({ currentLearningAssetStatus }) {
    let associateCollections = null;
    let licenscedCompanies = null;

    if (currentLearningAssetStatus.isInCollection === true) {
        associateCollections = (
            <Fragment>
                {currentLearningAssetStatus.associatedCollections.map((collection) => (
                    <div className={'row'} key={collection.name}>
                        <p className={'collection-name'}> - {collection.name}</p>
                    </div>
                ))}
            </Fragment>
        );
    } else if (currentLearningAssetStatus.isInCollection === false) {
        associateCollections = <p className={'collection-name'}> None</p>;
    }

    if (currentLearningAssetStatus.isLicensedByCompany === true) {
        licenscedCompanies = (
            <Fragment>
                {currentLearningAssetStatus.licensedCompanies.map((company) => (
                    <div className={'row'} key={company._id}>
                        <p className={'company-name'}> - {company.name}</p>
                    </div>
                ))}
            </Fragment>
        );
    } else if (currentLearningAssetStatus.isLicensedByCompany === false) {
        licenscedCompanies = <p className={'company-name'}> None</p>;
    }

    return (
        <div className={'learning-asset-status-panel'}>
            <label>STATUS</label>
            <div className={'associate-entity-container'}>
                <div className={'row'}>
                    <p className={'associated-entity'}>Associated collections:</p>
                </div>
                {associateCollections}
            </div>
            <div className={'associate-entity-container'}>
                <div className={'row'}>
                    <p className={'associated-entity'}>Licensed companies:</p>
                </div>
                {licenscedCompanies}
            </div>
        </div>
    );
}

LearningAssetStatusPanel.propTypes = {
    currentLearningAssetStatus: PropTypes.shape({
        associatedCollections: PropTypes.array,
        isInCollection: PropTypes.bool,
        isLicensedByCompany: PropTypes.bool,
        licensedCompanies: PropTypes.array
    })
};
